import React from "react"
import {Form} from "react-bootstrap"
import HeadingSkeleton from "../../../components/skeletons/HeadingSkeleton";

export default function EditQuestSkeleton({close, getListing, setGetListing, id}) {


    return(
        <div className={'add-gratitude'}>
            <Form>
                <div className={'dfields'}>
                    <HeadingSkeleton height={60} block={true}/>
                </div>
                <div className={'mt-10'}>
                    <HeadingSkeleton height={60} block={true}/>
                </div>
            </Form>
        </div>
    )
}